import { z } from 'zod'

import { BrevoRevenueReportStatus } from '@gto/api-client/admin/react-query'
import { enqueueABrevoRevenueAttributionReportBodyWindowDaysMaxOne } from '@gto/api-client/admin/zod'

export const REVENUE_WINDOW_MIN_DAYS = 1
export const REVENUE_WINDOW_MAX_DAYS = enqueueABrevoRevenueAttributionReportBodyWindowDaysMaxOne
export const RevenueWindowInputSchema = z
  .number()
  .int()
  .min(REVENUE_WINDOW_MIN_DAYS)
  .max(REVENUE_WINDOW_MAX_DAYS)

export const RevenueReportIdSchema = z.uuid()

export const RevenueReportsSearchSchema = z.object({
  status: z.array(z.enum(BrevoRevenueReportStatus)).optional().catch([]),
  window_days: RevenueWindowInputSchema.optional().catch(undefined),
  since: z.iso.date().optional().catch(undefined),
  until: z.iso.date().optional().catch(undefined),
})
export type RevenueReportsSearch = z.infer<typeof RevenueReportsSearchSchema>

const CompareIdSchema = z.string().optional().catch(undefined)

export const RevenueCompareSearchSchema = z.object({
  a: CompareIdSchema,
  b: CompareIdSchema,
})
export type RevenueCompareSearch = z.infer<typeof RevenueCompareSearchSchema>

export const RevenueReportPathParamsSchema = z.object({ id: RevenueReportIdSchema })
